module.exports = __webpack_public_path__ + "static/media/undraw_growth_analytics_8btt.f34a35f1.svg";